import React from 'react';
import styles from './style.module.css';
const index = ({ img, title, description, url = '/' }) => {
  return (
    <div className={styles.container}>
      <a href={url}>
        <div>
          <img src={img} alt={title} width="100%" />
        </div>
        <div className={styles.title}>
          <span className={styles.mainTitle}>{title}</span>
          <span className={styles.subTitle}>{description}</span>
        </div>
      </a>
    </div>
  );
};

export default index;
